import { useEffect, useState } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { getVendor, getVendorBySlug } from '@/api/catalog';
import { businessPath } from '@/lib/businessUrl';
import { isVendorUuid } from '@/lib/vendorUrl';
import { resolveSlugRedirect } from '@/api/seoRedirects';

export function LegacyBusinessRedirect() {
  const { id } = useParams<{ id: string }>();
  const [target, setTarget] = useState<string | null>(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    if (!id) {
      setMissing(true);
      return;
    }
    void (async () => {
      if (isVendorUuid(id)) {
        const vendor = await getVendor(id);
        if (vendor?.slug) {
          setTarget(businessPath(vendor));
          return;
        }
      }
      const redirected = await resolveSlugRedirect(id, 'vendor');
      if (redirected) {
        const vendor = await getVendorBySlug(redirected);
        if (vendor?.slug) {
          setTarget(businessPath(vendor));
          return;
        }
        setTarget(`/grenada/business/${redirected}`);
        return;
      }
      setMissing(true);
    })();
  }, [id]);

  if (target) return <Navigate to={target} replace />;
  if (missing) return <Navigate to="/grenada/vendors" replace />;
  return null;
}
